import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import MapIcon from "@material-ui/icons/Map";
import StorageIcon from "@material-ui/icons/Storage";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import TimelineIcon from "@material-ui/icons/Timeline";
import AssessmentIcon from "@material-ui/icons/Assessment";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: "fixed",
    right: "110px",
    top: "20px",
    zIndex: 999,
  },
}));

const actions = [
  { icon: <MapIcon />, name: "Maps" },
  { icon: <StorageIcon />, name: "Data" },
  // { icon: <LibraryBooksIcon />, name: "Libraries" },
  // { icon: <SupervisorAccountIcon />, name: "Manage DB" },
  { icon: <PlaylistAddCheckIcon />, name: "Cases" },
  { icon: <TimelineIcon />, name: "Analysis" },
  { icon: <AssessmentIcon />, name: "Results" },
];

const actionsNonAdmin = [
  { icon: <MapIcon />, name: "Maps" },
  { icon: <StorageIcon />, name: "Data" },
  // { icon: <LibraryBooksIcon />, name: "Libraries" },
  { icon: <PlaylistAddCheckIcon />, name: "Cases" },
  { icon: <TimelineIcon />, name: "Analysis" },
  { icon: <AssessmentIcon />, name: "Results" },
];

export const SpeedDials = ({ isStaff }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  let history = useHistory();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCloseMenu = () => {
    setOpen(false);
  };

  const handleRedirect = (action) => {
    setOpen(false);
    if (action.name === "Maps") {
      history.push("/dashboard/maps/fixed_zero");
    } else if (action.name === "Data") {
      history.push("/dashboard/data/wind_turbines");
    }
    // else if (action.name === "Libraries") {
    //   history.push("/dashboard/libraries");
    // }
    // else if (action.name === "Manage DB") {
    //   history.push("/dashboard/managedb/irradiance/fixed");
    // }
    else if (action.name === "Cases") {
      history.push("/dashboard/cases/yourcases");
    } else if (action.name === "Analysis") {
      history.push("/dashboard/analysis/parameters/technologies");
    } else if (action.name === "Results") {
      history.push("/dashboard/results/photovoltaic/productivity");
    }
  };

  return (
    <React.Fragment>
      {isStaff ? (
        <SpeedDial
          ariaLabel="SpeedDial tooltip example"
          className={classes.speedDial}
          hidden={hidden}
          icon={<i style={{ fontSize: "24px" }} className="fa fa-bars"></i>}
          onClose={handleCloseMenu}
          onOpen={handleOpen}
          open={open}
          direction="down"
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipOpen
              onClick={() => handleRedirect(action)}
            />
          ))}
        </SpeedDial>
      ) : (
        <SpeedDial
          ariaLabel="SpeedDial tooltip example"
          className={classes.speedDial}
          hidden={hidden}
          icon={<i style={{ fontSize: "24px" }} className="fa fa-bars"></i>}
          onClose={handleCloseMenu}
          onOpen={handleOpen}
          open={open}
          direction="down"
        >
          {actionsNonAdmin.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipOpen
              onClick={() => handleRedirect(action)}
            />
          ))}
        </SpeedDial>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(SpeedDials);
